import { useEffect, useState } from "react";
import { fetchAllyPreviewAsync, fetchLoginURLAsync } from "../services/settingsURL/settingURL.service.ts";

let cachedUrls: {
  allyPreviewURL: string | null;
  loginURL: string | null;
} = { allyPreviewURL: null, loginURL: null };

export const useSettingURL = () => {
  const [loginURL, setLoginURL] = useState<string | null>(null);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const fetchURL = async () => {
      try {
        if (cachedUrls.loginURL) {
          setLoginURL(cachedUrls.loginURL);
        } else {
          const data = await fetchLoginURLAsync();
          if (data?.LoginURL) {
            cachedUrls.loginURL = data.LoginURL;
            setLoginURL(data.LoginURL);
          } else {
            setError("Login URL not found");
          }
        }
      } catch (err) {
        setError("Failed to fetch Login URL");
        console.error(err);
      }
    };

    fetchURL();
  }, []);

  return { loginURL, error };
};

export const useAllyPreviewURL = () => {
  const [allyPreviewURL, setAllyPreviewURL] = useState<string | null>(null);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const getUrls = async () => {
      try {
        if (cachedUrls.allyPreviewURL) {
          setAllyPreviewURL(cachedUrls.allyPreviewURL);
        } else {
          const urls = await fetchAllyPreviewAsync();
          if (urls?.values?.AllyPreviewURL) {
            cachedUrls.allyPreviewURL = `${urls.values.AllyPreviewURL}/asset/status`;
            setAllyPreviewURL(cachedUrls.allyPreviewURL);
          } else {
            setError("Ally Preview URL not found");
          }
        }
      } catch (err) {
        setError("Failed to fetch Ally Preview URL");
        console.error(err);
      }
    };

    getUrls();
  }, []);

  return { allyPreviewURL, error };
};
